// src/Settings.js
import React, { useEffect, useState } from 'react';
import {
  getTheme,
  getReduceMotion,
  setTheme,
  setReduceMotion,
} from './appearance';

function Switch({ checked, onChange, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      className="settings-switch"
      onClick={() => onChange(!checked)}
    />
  );
}

export default function Settings({ onClose }) {
  const [isClosing, setIsClosing] = useState(false);
  const [dark, setDark] = useState(() => getTheme() === 'dark');
  const [reduced, setReduced] = useState(() => getReduceMotion());

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 250);
  };

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleDark = (value) => {
    setDark(value);
    setTheme(value ? 'dark' : 'light');
  };

  const toggleReduced = (value) => {
    setReduced(value);
    setReduceMotion(value);
  };

  return (
    <div
      className={`settings-overlay ${isClosing ? 'closing' : ''}`}
      onClick={handleClose}
    >
      <div
        className="settings-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Настройки"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="settings-close" onClick={handleClose} aria-label="Закрыть">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="settings-header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
          </svg>
          <h2>Настройки</h2>
        </div>

        <div className="settings-body">
          <div className="settings-option">
            <div className="settings-option-text">
              <span className="settings-option-title">Тёмная тема</span>
              <span className="settings-option-desc">
                Тёмное оформление сайта — комфортнее для глаз при слабом освещении.
              </span>
            </div>
            <Switch checked={dark} onChange={toggleDark} label="Тёмная тема" />
          </div>

          <div className="settings-option">
            <div className="settings-option-text">
              <span className="settings-option-title">Меньше анимаций</span>
              <span className="settings-option-desc">
                Отключает переходы, движущиеся фоны и размытие. Ускоряет работу
                сайта на слабых компьютерах и планшетах.
              </span>
            </div>
            <Switch
              checked={reduced}
              onChange={toggleReduced}
              label="Меньше анимаций"
            />
          </div>

          <p className="settings-hint">
            Настройки сохраняются в этом браузере и применяются сразу.
          </p>
        </div>
      </div>
    </div>
  );
}
